import React, { useState } from 'react'
import styled from '@emotion/styled'

import { white } from '../../constants/principles'
import { BrowserUtils } from '../../utils/siteUtils'
import Error from './Error'
import ErrorBoundary from './ErrorBoundaryDoNothing'
import Textbox from './floatingText'
import VinScan from './VinScan'

export default ({ vin, onChange, onScanSuccess, error, setError, isAdmin, setClicked, updateGlobalState, testId, onClick = () => {} }) => {
  const [showVinScan, setShowVinScan] = useState(false)
  const [vinScanError, setvinScanError] = useState('')
  const enableScanner = BrowserUtils.isMobile() && !BrowserUtils.isIE() && !BrowserUtils.isIOSAndChrome()

  return (
    <>
      <Textbox
        testId={testId}
        backgroundColor={white}
        fullWidth={true}
        value={vin || ''}
        label="VIN"
        placeholder="Enter the 17-digit VIN"
        maxLength={17}
        onClick={e => onClick(e)}
        onChange={newValue => {
          if (newValue.replace(/ /, '').length <= 17) {
            onChange(newValue.replace(/ /, ''))
          }
          setError(false)
          setClicked && setClicked(false)
        }}
        isError={error}
        autoFocus={true}
        disabled={process.env.BUILD_STAGE === 'build-html'}
        id={'vin-entry'}>
        {enableScanner && (
          <StyledImg
            onClick={() => {
              setShowVinScan(true)
              updateGlobalState({ fireAnalytics: 'timbuybkhome_selltrade_vinscan_button' })
            }}
            alt="check"
            src={__PATH_PREFIX__ + '/camera_scan.svg'}
          />
        )}
      </Textbox>
      {vinScanError && <Error isError={true} text={vinScanError} id={'vinScan-error'} />}
      {enableScanner && showVinScan && (
        <ErrorBoundary>
          <VinScan
            closeVinScan={() => setShowVinScan(false)}
            onSuccess={vin => {
              onChange(vin)
              onScanSuccess(vin)
            }}
            onError={(...e) => {
              setvinScanError('Something went wrong during the scan, try again or manually enter the vin number')
              console.log(e)
            }}
            updateGlobalState={updateGlobalState}
          />
        </ErrorBoundary>
      )}
    </>
  )
}

const StyledImg = styled.img`
  width: 32px;
  height: 32px;
  align-self: center;
  cursor: pointer;
`
